
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 13","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.25 6.5c-.563 0-1.055-.117-1.523-.398a2.654 2.654 0 01-1.079-1.079c-.28-.468-.398-.96-.398-1.523 0-.54.117-1.031.398-1.5.258-.469.61-.82 1.079-1.102A3.08 3.08 0 015.25.5c.54 0 1.031.14 1.5.398A3.1 3.1 0 017.852 2a3.061 3.061 0 010 3.023c-.282.47-.633.82-1.102 1.079-.469.28-.96.398-1.5.398zm2.11.75c.562 0 1.077.14 1.57.422.468.281.867.68 1.148 1.148.281.492.422 1.008.422 1.57v.985c0 .328-.117.586-.328.797a1.062 1.062 0 01-.797.328h-8.25c-.328 0-.586-.094-.797-.328C.094 11.96 0 11.703 0 11.375v-.984c0-.563.14-1.079.422-1.57A3.173 3.173 0 011.57 7.67a3.033 3.033 0 011.57-.421h.4a3.87 3.87 0 001.71.375 4.02 4.02 0 001.71-.375h.4z","opacity":".6"}})])
          )
        }
      }
    